export class Login {
    constructor(
        public email: string,
        public password: string,
        public rememberMe: boolean,
    ) {}
}



// WEBPACK FOOTER //
// ./ts/app/login/login.ts